import { render, staticRenderFns } from "./LawNormForm.vue?vue&type=template&id=49724d4a&scoped=true"
import script from "./LawNormForm.vue?vue&type=script&lang=js"
export * from "./LawNormForm.vue?vue&type=script&lang=js"
import style0 from "./LawNormForm.vue?vue&type=style&index=0&id=49724d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49724d4a",
  null
  
)

export default component.exports